import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { ComponentsModule } from 'app/shared/components/components.module';
import { FormFeatureModule } from 'app/shared/components/form/form.feature.module';
import { TableModule } from 'app/shared/components/custom-table/table.module';
import { ToolModule } from 'app/tool/tool.module';
import { SharedModule } from 'app/shared/shared.module';

import { ToolRequestLinesComponent } from "./pages/tool-request-lines/tool-request-lines.component";
import {
    ProcessToolRequestComponent,
    ReplaceToolModalComponent,
    ToolRequestLinesTableComponent,
} from "@app/roles/atom-operator/pages/tool-request-lines/components";

import {
    ToolReturnsComponent,
    ToolReturnsInspectComponent,
    ToolReturnsTableComponent
} from './pages/tool-returns';

import { ToolRequestsFacilitiesComponent } from './pages/tool-requests-facilities/tool-requests-facilities.component';
import {
    ProcessToolRequestsFacilitiesComponent,
    ToolRequestFacilitiesToolsTableComponent,
    ToolRequestsFacilitiesTableComponent
} from "@app/roles/atom-operator/pages/tool-requests-facilities/components";

import { ToolReturnsFacilitiesComponent } from './pages/tool-returns-facilities/tool-returns-facilities.component';
import {
    ToolReturnsFacilitiesInspectComponent,
    ToolReturnsFacilitiesTableComponent
} from "@app/roles/atom-operator/pages/tool-returns-facilities/components";
import { ResolutionService } from "@services/resolution.service";

@NgModule({
    declarations: [
        ReplaceToolModalComponent,
        ToolRequestLinesComponent,
        ToolRequestLinesTableComponent,
        ToolRequestsFacilitiesComponent,
        ToolRequestFacilitiesToolsTableComponent,
        ToolRequestsFacilitiesTableComponent,
        ToolReturnsComponent,
        ToolReturnsTableComponent,
        ToolReturnsInspectComponent,
        ProcessToolRequestComponent,
        ProcessToolRequestsFacilitiesComponent,
        ReplaceToolModalComponent,
        ToolReturnsFacilitiesComponent,
        ToolReturnsFacilitiesTableComponent,
        ToolReturnsFacilitiesInspectComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ComponentsModule,
        FormFeatureModule,
        TableModule,
        ToolModule,
        TranslateModule,
        SharedModule,
    ],
    providers: [
        ResolutionService
    ],
    bootstrap: []
})
export class AtomOperatorModule {
}
